import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const HelpCenter = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.474 4.577C6.466 2.586 9.175 1.25 12.006 1.25c2.83 0 5.54 1.336 7.53 3.326 1.99 1.99 3.323 4.697 3.317 7.522 0 5.657-4.864 10.183-10.9 10.582-3.97.269-6.576-.303-7.945-.603a46.823 46.823 0 0 0-.343-.074c-.482-.1-1.056-.296-1.406-.716a1.257 1.257 0 0 1-.299-.902c.024-.335.175-.628.363-.87l.005-.006A61.697 61.697 0 0 1 3.52 18.08c-1.462-1.687-2.373-4.098-2.373-5.971 0-2.83 1.336-5.54 3.327-7.532Zm10.463 5.334-.001-.033a2.964 2.964 0 0 0-2.96-2.927 2.964 2.964 0 0 0-2.96 2.96.79.79 0 0 0 1.578 0 1.383 1.383 0 1 1 1.923 1.272 2.202 2.202 0 0 0-1.33 2.033v.051a.79.79 0 0 0 1.578 0v-.05c0-.257.146-.485.373-.581a2.958 2.958 0 0 0 1.799-2.725Zm-1.96 6.51a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    />
  </Icon>
);

export default HelpCenter;
